export enum LeaderboardSortingEnum {
  Score = 'score',
  ScoreTime = 'scoreTime',
  Time = 'time'
}
